import { render } from "./MyResponsibilities.vue?vue&type=template&id=6d1c70dc&scoped=true"
import script from "./MyResponsibilities.vue?vue&type=script&lang=js"
export * from "./MyResponsibilities.vue?vue&type=script&lang=js"

import "./MyResponsibilities.vue?vue&type=style&index=0&id=6d1c70dc&scoped=true&lang=css"
import "./MyResponsibilities.vue?vue&type=style&index=1&id=6d1c70dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1c70dc"]])

export default __exports__